import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import FacturacionReport from "../Facturacion/Facturacion";

const DetailModal = ({ modal, setModal }) => {
  const handleClose = () => {
    setModal({ ...modal, show: false });
  };

  return (
    <div>
      <Modal isOpen={modal.show} className="modal-dialog modal-xl">
        <ModalHeader className="bg-primary">
          Detalle de reseller: {modal.name}
        </ModalHeader>
        <ModalBody>
          <FacturacionReport
            date={modal.date}
            company_id={modal.company_id}
            className="modal-facturacion"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DetailModal;
